export default "__VITE_ASSET__e0c812ad__"